// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface InternalendpointsSessionDetailsSpec
 */
export interface InternalendpointsSessionDetailsSpec {
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  alias?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  consoleTenantId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  consoleUserId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  cpu?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  databaseUsername?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  dbInstanceId?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  dnsName?: string;
  /**
   *
   * @type {{ [key: string]: boolean; }}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  featureFlags?: { [key: string]: boolean };
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  inactivityExpiry?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  maxLifeTime?: string;
  /**
   *
   * @type {string}
   * @memberof InternalendpointsSessionDetailsSpec
   */
  memory?: string;
}

/**
 * Check if a given object implements the InternalendpointsSessionDetailsSpec interface.
 */
export function instanceOfInternalendpointsSessionDetailsSpec(
  value: object,
): value is InternalendpointsSessionDetailsSpec {
  return true;
}

export function InternalendpointsSessionDetailsSpecFromJSON(
  json: any,
): InternalendpointsSessionDetailsSpec {
  return InternalendpointsSessionDetailsSpecFromJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalendpointsSessionDetailsSpec {
  if (json == null) {
    return json;
  }
  return {
    alias: json['alias'] == null ? undefined : json['alias'],
    consoleTenantId:
      json['console_tenant_id'] == null ? undefined : json['console_tenant_id'],
    consoleUserId:
      json['console_user_id'] == null ? undefined : json['console_user_id'],
    cpu: json['cpu'] == null ? undefined : json['cpu'],
    databaseUsername:
      json['database_username'] == null ? undefined : json['database_username'],
    dbInstanceId:
      json['db_instance_id'] == null ? undefined : json['db_instance_id'],
    dnsName: json['dns_name'] == null ? undefined : json['dns_name'],
    featureFlags:
      json['feature_flags'] == null ? undefined : json['feature_flags'],
    inactivityExpiry:
      json['inactivity_expiry'] == null ? undefined : json['inactivity_expiry'],
    maxLifeTime:
      json['max_life_time'] == null ? undefined : json['max_life_time'],
    memory: json['memory'] == null ? undefined : json['memory'],
  };
}

export function InternalendpointsSessionDetailsSpecToJSON(
  json: any,
): InternalendpointsSessionDetailsSpec {
  return InternalendpointsSessionDetailsSpecToJSONTyped(json, false);
}

export function InternalendpointsSessionDetailsSpecToJSONTyped(
  value?: InternalendpointsSessionDetailsSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alias: value['alias'],
    console_tenant_id: value['consoleTenantId'],
    console_user_id: value['consoleUserId'],
    cpu: value['cpu'],
    database_username: value['databaseUsername'],
    db_instance_id: value['dbInstanceId'],
    dns_name: value['dnsName'],
    feature_flags: value['featureFlags'],
    inactivity_expiry: value['inactivityExpiry'],
    max_life_time: value['maxLifeTime'],
    memory: value['memory'],
  };
}
